import logo from './logo.svg';
import './App.css';
import Intro from './components/Intro';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Intro />
      </header>

    </div>
  );
}

export default App;
